<template>

	<div class="px-4 sm:px-0 md:max-w-2xl lg:max-w-4xl xl:max-w-6xl mx-auto my-10 bg-yellow-700 text-white sm:p-12 rounded-lg">
		<div class="flex flex-wrap -mx-2 py-12 sm:py-2">
			<div class="w-full sm:w-1/2 md:w-1/4 px-2 text-center py-2">
				<div class="text-2xl font-semibold leading-8">12</div>
				<div class="text-xl mt-1">Project completed</div>
			</div>
			<div class="w-full sm:w-1/2 md:w-1/4 px-2 text-center py-2">
				<div class="text-2xl font-semibold leading-8">10</div>
				<div class="text-xl mt-1">Clients happy</div>
			</div>
			<div class="w-full sm:w-1/2 md:w-1/4 px-2 text-center py-2">
				<div class="text-2xl font-semibold leading-8">30</div>
				<div class="text-xl mt-1">Creative design</div>
			</div>
			<div class="w-full sm:w-1/2 md:w-1/4 px-2 text-center py-2">
				<div class="text-2xl font-semibold leading-8">2+yrs</div>
				<div class="text-xl mt-1">Experience</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: "WorkCount"
	}
</script>

<style scoped>

</style>
